import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid} from 'react-bootstrap';
import {Map} from 'immutable';

import {Wrapper} from '../system/wrapper';
import Input from 'form/input';
import Checkbox from 'form/checkbox';
import {ButtonRegistrationLogin} from 'components/buttons';
import {FailedLogin} from './components';
import {registration, acceptRegistration, changeRegistrationValue, changeRegistrationItem, cleanAuthForm} from 'redux/actions/auth';

const mapStateToProps = state => ({
  accept: state.auth.get('registrationAccept'),
  item: state.auth.get('registrationItem'),
  isLoading: state.auth.get('isLoading'),
  hasError: state.auth.get('hasError'),
  token: state.auth.get('token')
});

const mapDispatchToProps = dispatch => ({
  changeAccept: (event) => dispatch(acceptRegistration(event.target.checked)),
  changeValue: (value, key) => dispatch(changeRegistrationValue(value, key)),
  onSubmit: (event) => {
    event.preventDefault();
    dispatch(registration())
  },
  cleanAuthForm: () => {
    dispatch(cleanAuthForm())
    dispatch(changeRegistrationItem(new Map()))
  }
});

class Registration extends Component {

  generateError = (error) => { //TODO: make file with all errors and map on file
    if (!error) return
    let msg = ''
    if (error.email && error.email[0] === "Enter a valid email address.") {
      msg = 'Ви ввели невірний email.'
    } else if (error.non_field_errors && error.non_field_errors[0] === "A user with that email already exists.") {
      msg = 'Обліковий запис з такою поштою вже існує. Будь ласка, введіть іншу пошту.'
    } else {
      msg = 'При реєстрації виникла помилка. Перевірте, будь ласка, правильність введення всіх полів.'
    }
    return <FailedLogin>{msg}</FailedLogin>
  }


  componentDidMount() {
    this.props.cleanAuthForm();
  }

  componentWillUnmount(){
    this.props.cleanAuthForm();
  }


  render() {
    return (
      <div>
        <Wrapper>
          <Grid>
            <h2>Реєстрація</h2>
            <form onSubmit={this.props.onSubmit} style={{display: "flex", flexDirection: "column"}}>
              <Input
                label="Прізвище:"
                type="text"
                placeholder="Введіть Ваше прізвище"
                value={this.props.item.get('last_name') ? this.props.item.get('last_name') : ""}
                onChange={(event) => this.props.changeValue(event.target.value, 'last_name')}
                required
              />
              <Input
                label="Ім'я:"
                type="text"
                placeholder="Введіть Ваше ім'я"
                value={this.props.item.get('first_name') ? this.props.item.get('first_name') : ""}
                onChange={(event) => this.props.changeValue(event.target.value, 'first_name')}
                required
              />
              <Input
                label="По батькові:"
                type="text"
                placeholder="Введіть Ваше ім’я по батькові"
                value={this.props.item.get('middle_name') ? this.props.item.get('middle_name') : ""}
                onChange={(event) => this.props.changeValue(event.target.value, 'middle_name')}
                required
              />
              <Input
                label="Пошта:"
                type="email"
                placeholder="Введіть Ваш email"
                value={this.props.item.get('email') ? this.props.item.get('email') : ""}
                onChange={(event) => this.props.changeValue(event.target.value, 'email')}
                required
              />
              <Input
                label="Пароль:"
                type="password"
                placeholder="Введіть Ваш пароль"
                value={this.props.item.get('password1') ? this.props.item.get('password1') : ""}
                onChange={(event) => this.props.changeValue(event.target.value, 'password1')}
                required
              />
              <Input
                label="Підтердіть пароль:"
                type="password"
                placeholder="Введіть Ваш пароль ще раз"
                value={this.props.item.get('password2') ? this.props.item.get('password2') : ""}
                onChange={(event) => this.props.changeValue(event.target.value, 'password2')}
                required
              />
              <Input
                label="Телефон:"
                type="text"
                placeholder="Введіть Ваш номер телефону"
                value={this.props.item.get('phone') ? this.props.item.get('phone') : ""}
                onChange={(event) => this.props.changeValue(event.target.value, 'phone')}
                required
              />
              <Input
                label="Адреса:"
                type="text"
                placeholder="Введіть Вашу адресу"
                value={this.props.item.get('address') ? this.props.item.get('address') : ""}
                onChange={(event) => this.props.changeValue(event.target.value, 'address')}
              />
              <Input
                label="ІПН:"
                type="text"
                placeholder="Введіть Ваш ІПН"
                value={this.props.item.get('tax_number') ? this.props.item.get('tax_number') : ""}
                onChange={(event) => this.props.changeValue(event.target.value, 'tax_number')}
              />
              <Checkbox
                type="checkbox"
                label="Погоджуюсь на обробку моїх персональних даних"
                checked={this.props.accept}
                onChange={this.props.changeAccept}
              />
              {this.generateError(this.props.hasError)}
              {this.props.accept && !this.props.isLoading ? (
                <ButtonRegistrationLogin type="submit" value="Зареєструватись" />
              ): (
                <ButtonRegistrationLogin disabled type="submit" value="Зареєструватись" />
              )}


            </form>
          </Grid>
        </Wrapper>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Registration);



// WEBPACK FOOTER //
// ./src/auth/registration.js